/**
 * HPH white-label: block shopping cart and show a contact-support notice.
 * Set ENABLED to false to remove the gate without deleting call sites.
 */
export const HPH_CART_GATE = {
  ENABLED: false,
  SUPPORT_EMAIL: 'general@capitalplatforms.com',
  COMPANY_CODE: 'HPH',
} as const;

export function isHphCartBlocked(identity: {
  username?: string | null;
  companyCode?: string | null;
  whitelabelCode?: string | null;
}): boolean {
  if (!HPH_CART_GATE.ENABLED) {
    return false;
  }

  const username = (identity.username ?? '').trim().toUpperCase();
  const companyCode = (identity.companyCode ?? '').trim().toUpperCase();
  const whitelabelCode = (identity.whitelabelCode ?? '').trim().toUpperCase();

  return (
    username.startsWith(HPH_CART_GATE.COMPANY_CODE) ||
    companyCode === HPH_CART_GATE.COMPANY_CODE ||
    whitelabelCode === HPH_CART_GATE.COMPANY_CODE
  );
}
